/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsWallet: {
  name: 'wallet';
  data: string;
} = {
  name: 'wallet',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 8a2 2 0 0 1 2-2h7V5H4v14h13v-1h-7a2 2 0 0 1-2-2V8Zm10 0h2v8H10V8h8Zm2 10h-1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v1h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Zm-7-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
